// extracted by mini-css-extract-plugin
export var badge = "_h1-2";
export var detailsPanel = "_h1-0";
export var resultRow = "_h1-1";